import { Box, styled } from '@mui/joy';

export const ContentWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flex: 1,
  gap: '16px',
  scrollMarginTop: '128px', //Big enough to not hide the form Notification
});

export const FieldWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 'inherit',
});
